import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./landing/landing.page').then((m) => m.LandingPage),
  },
  {
    path: 'about',
    loadComponent: () => import('./about/about.page').then((m) => m.AboutPage),
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'signup',
    loadComponent: () => import('./signup/signup.page').then((m) => m.SignupPage),
  },
  {
    path: 'privacy',
    loadComponent: () => import('./privacy/privacy.page').then((m) => m.PrivacyPage),
  },
  {
    path: 'home',
    loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
    canActivate: [AuthGuard]
  },
  {
    path: 'invite',
    loadComponent: () => import('./invite/invite.page').then((m) => m.InvitePage),
    canActivate: [AuthGuard]
  },
  {
    path: 'premium',
    loadComponent: () => import('./premium/premium.page').then((m) => m.PremiumPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'subscription',
    loadComponent: () => import('./subscription/subscription.page').then((m) => m.SubscriptionPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'menu-planning',
    loadComponent: () => import('./menu-planning/menu-planning.page').then((m) => m.MealPlannerPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'recipes-landing',
    loadComponent: () => import('./recipes-landing/recipes-landing.page').then((m) => m.RecipesLandingPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'recipes',
    loadComponent: () => import('./recipes/recipes.page').then((m) => m.RecipesPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'recipe-book',
    loadComponent: () => import('./recipe-book/recipe-book.page').then((m) => m.RecipeBookPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'recipe-editor/:id',
    loadComponent: () => import('./recipe-editor/recipe-editor.page').then((m) => m.RecipeEditorPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'meal-planner',
    loadComponent: () => import('./meal-planner/meal-planner.page').then((m) => m.MealPlannerPage),
    canActivate: [AuthGuard]
  },
];
